import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import APP_CONSTANTS, { MESSAGES } from "../../../utils/config";
import { useTheme } from "@emotion/react";
import { Tab } from "@mui/material";
import { Tabs } from "@mui/material";
import { a11yProps, normalizeList } from "../../../utils/utils";
import InfraPage from "./InfraPage";
import CostApprovalPage from "./CostApprovalPage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchRapidApplication } from "../../../services/api";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import { useDispatch } from "react-redux";
import Error from "../Component/Error";
import {
  updateRapidAppStatus,
  updateRapidDetailsData,
  updateRapidInfraData,
  updateTotalCostData,
  updateAIModelsJsonData,
  updateAccLibraryJsonData,
} from "../../../redux/slice/dataSlice";
import Loader from "../../../components/Loader/Loader";
import { useFetchOwnersData } from "../../MyApps/useFetchData";
import { useSelector } from "react-redux";
import TrackStatus from "./TrackStatus";
import DetailsPage from "./DetailsPage";
import PageNotFound from "../../NoAccess/NoAccess";
import ChooseAIModel from "./ChooseAIModel";
import AcceleratorLibraryPage from "./AcceleratorLibraryPage";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            pl: 0,
            pr: 0,
            // height: "100%",
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

function RapidEditContainer() {
  const [value, setValue] = useState(0);
  const theme = useTheme();

  const is_admin =
    useSelector((state) => state.auth.metadata?.rapid?.is_admin) || false;

  const isRapidAccess = useSelector(
    (state) => state.auth.metadata?.rapid?.access || false
  );

  const appStatus =
    useSelector((state) => state.data.rapidData?.current_status) || "";

  const param = useParams();
  const register_id = param?.id;
  const [loading, setLoading] = useState({
    status: "loading",
    message: "Edit Application loading",
  });

  const dispatch = useDispatch();
  const userEmail = useSelector((state) => state.auth?.metadata?.email);
  let total_cost = useSelector((state) => state.data.rapidData?.total_cost);
  total_cost = total_cost === "loading" ? "..." : "$ " + total_cost.toFixed(2);

  const tabsHeader = [
    "Request Details",
    "Project Type And Components",
    "Accelerator Libraries",
    "Choose AI Model",
    `Total Cost (${total_cost})`,
    "Track Status",
  ];

  const fetchRapidApplicationData = async () => {
    setLoading({
      status: "loading",
      message: "Edit Application loading",
    });

    try {
      const resp = await fetchRapidApplication({
        params: {
          register_id: register_id,
        },
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        const data = resp.data?.data;
        // Ensure LeanIX id and Gen AI options are present in Project Type & Components
        let infra =
          data?.infraResources || data?.infra_details || data?.infrajson;

        try {
          if (
            Array.isArray(infra) &&
            infra[1] &&
            Array.isArray(infra[1].components)
          ) {
            const comps = infra[1].components;
            const hasGenAI = comps.some((c) => c?.component_id === 35);
            const updatedComps = [...comps];

            if (!hasGenAI) {
              updatedComps.splice(2, 0, {
                component_id: 35,
                component_name: "Gen AI options",
                component_type: "multi-select-dropdown",
                description: "Select Gen AI model options",
                info: "",
                is_required: false,
                properties: [],
                value: [],
              });
              infra = [
                ...infra.slice(0, 1),
                { ...infra[1], components: updatedComps },
                ...infra.slice(2),
              ];
            } else {
              const genAIComponent = updatedComps.filter(
                (item) => item.component_id === 35
              );
              let propertyList = genAIComponent[0]?.properties;
              let propertyListModified = propertyList.map((item) => {
                return {
                  ...item,
                  cost: item?.cost ? item.cost : 0,
                  score: item?.score ? item.score : 0,
                };
              });
              const valueList = genAIComponent[0]?.value;
              const valueListModified = normalizeList(
                valueList,
                propertyListModified
              );
              const modifiedComponents = updatedComps.map((item) => {
                if (item.component_id === 35) {
                  return {
                    ...item,
                    properties: propertyListModified,
                    value: valueListModified,
                  };
                } else {
                  return item;
                }
              });
              infra = [
                ...infra.slice(0, 1),
                { ...infra[1], components: modifiedComponents },
                ...infra.slice(2),
              ];
            }
          }
        } catch (e) {
          console.err("Error", e);
        }

        dispatch(updateRapidInfraData(infra));
        dispatch(updateRapidDetailsData(data?.details));
        dispatch(updateRapidAppStatus(data?.status));

        data?.choose_ai_models === null ||
        data?.choose_ai_models?.length === 0 ||
        Object.keys(data?.choose_ai_models)?.length <= 3
          ? dispatch(
              updateAIModelsJsonData({
                usecases: [],
                priority_1: "",
                priority_2: "",
                priority_3: "",
              })
            )
          : dispatch(updateAIModelsJsonData(data?.choose_ai_models));

        dispatch(updateAccLibraryJsonData(data?.accelerator_libraries || {}));
        setLoading({
          status: "success",
          message: message,
        });
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
        setLoading({
          status: "error",
          message: message,
        });
      }
    } catch (err) {
      console.error("Error", err);
      setLoading({
        status: "error",
        message: "Internal Server Error",
      });
    }
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (isRapidAccess) {
      fetchRapidApplicationData();
    }

    return () => {
      dispatch(updateTotalCostData("loading"));
    };
  }, []);

  const handleChangeScreen = (newValue) => {
    setValue(newValue);
  };
  return (
    <>
      {isRapidAccess ? (
        <div style={{ margin: theme.size[24], height: "calc(100vh - 105px)" }}>
          {/* Header */}
          <Typography
            sx={{
              fontWeight: theme.fontWeight[500],
              fontSize: theme.size[15],
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "calc(100vw - 460px)",
              color: theme.palette.primary.darkViolet,
            }}
          >
            {MESSAGES.RAPID}
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              margin: "8px 0 16px 0",
            }}
          >
            <Typography
              sx={{
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
                color: theme.palette.primary.darkViolet,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/rapid");
              }}
            >
              RAPID
            </Typography>
            <Typography
              sx={{
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
                color: theme.palette.secondary.main,
                margin: "0 5px",
              }}
            >
              /
            </Typography>
            <Typography
              sx={{
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
                color: theme.palette.primary.darkViolet,
                opacity: 0.5,
              }}
            >
              Request ID: {register_id}
            </Typography>
          </div>

          {/* Stepper */}
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              position: "absolute",
              top: 140,
              width: "calc(100% - 64px)",
              zIndex: 1,
              background: theme.palette.tertiary.light,
              //   margin: "10px 0px",
            }}
          >
            <Tabs
              value={value}
              onChange={(event, newValue) => handleChangeScreen(newValue)}
              aria-label="Report Details Tab"
              indicatorColor="secondary"
              sx={{
                margin: `${theme.size[0]} ${theme.size[0]}`,
              }}
            >
              {tabsHeader.map((elem, index) => (
                <Tab
                  key={index}
                  label={`${elem}`}
                  style={{
                    textTransform: "capitalize",
                    color: theme.palette.primary.main,
                    minWidth: 0,
                    margin: "0 24px 0 0",
                    padding: 0,
                  }}
                  {...a11yProps(index)}
                  disableRipple
                />
              ))}
            </Tabs>
          </Box>

          {loading.status === "loading" ? (
            <Loader />
          ) : loading.status === "success" ? (
            <>
              <TabPanel
                style={{
                  marginTop: "80px",
                  maxHeight: "100%",
                  height: "calc(100vh - 230px)",
                  overflow: "scroll",
                }}
                value={value}
                index={0}
              >
                <DetailsPage
                  isRegistering={false}
                  register_id={register_id}
                  userEmail={userEmail}
                  handleNext={() => {}}
                  handleBack={() => {}}
                />
              </TabPanel>
              <TabPanel
                style={{
                  marginTop: "80px",
                  maxHeight: "100%",
                  height: "calc(100vh - 230px)",
                  overflow: "scroll",
                }}
                value={value}
                index={1}
              >
                <InfraPage
                  isRegistering={false}
                  register_id={register_id}
                  userEmail={userEmail}
                  appStatus={appStatus}
                  handleNext={() => {}}
                  handleBack={() => {}}
                />
              </TabPanel>
              <TabPanel
                style={{
                  marginTop: "80px",
                  maxHeight: "100%",
                  height: "calc(100vh - 230px)",
                  overflow: "hidden",
                }}
                value={value}
                index={2}
              >
                <AcceleratorLibraryPage
                  handleNext={() => {}}
                  handleBack={() => {}}
                  isRegistering={false}
                  register_id={register_id}
                />
              </TabPanel>
              <TabPanel
                style={{
                  marginTop: "80px",
                  maxHeight: "100%",
                  height: "calc(100vh - 230px)",
                  overflow: "scroll",
                }}
                value={value}
                index={3}
              >
                <ChooseAIModel
                  handleNext={() => {}}
                  handleBack={() => {}}
                  isRegistering={false}
                />
              </TabPanel>
              <TabPanel
                style={{
                  marginTop: "80px",
                  maxHeight: "100%",
                  height: "calc(100vh - 230px)",
                  overflow: "scroll",
                  position: "relative",
                }}
                value={value}
                index={4}
              >
                <CostApprovalPage
                  isRegistering={false}
                  register_id={register_id}
                  status={appStatus}
                  is_admin={false}
                  handleBack={() => {}}
                  userEmail={userEmail}
                />
              </TabPanel>
              <TabPanel
                style={{
                  marginTop: "80px",
                  maxHeight: "100%",
                  height: "calc(100vh - 230px)",
                  overflow: "scroll",
                }}
                value={value}
                index={5}
              >
                <TrackStatus isRegistering={false} register_id={register_id} />
              </TabPanel>
            </>
          ) : (
            <Error
              message={loading.message}
              imageHeight={"20vh"}
              height={"80%"}
              retryFunction={fetchRapidApplicationData}
            />
          )}
        </div>
      ) : (
        <PageNotFound />
      )}
    </>
  );
}

export default RapidEditContainer;
